export default "__VITE_ASSET__DCJXTxR1__"